/**
 * Converts a possibly relative status URL to an absolute one.
 * If the URL is already absolute (starts with http/https), it is returned unchanged.
 */
export function toAbsolute(statusUrl: string, baseUrl?: string): string {
  if (baseUrl === undefined) return statusUrl;
  if (/^https?:\/\//i.test(statusUrl)) return statusUrl;
  return `${baseUrl.replace(/\/$/, '')}/${statusUrl.replace(/^\//, '')}`;
}
